var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#5570F1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4771_21968)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5871 11.1628L21.2365 12.5134C21.0988 12.6511 20.8761 12.6511 20.7384 12.5134L17.4865 9.26147C17.3488 9.12378 17.3488 8.90112 17.4865 8.76343L18.8371 7.41284C19.3849 6.86499 20.2756 6.86499 20.8263 7.41284L22.5871 9.17358C23.1379 9.72144 23.1379 10.6121 22.5871 11.1628ZM16.3263 9.92358L8.63297 17.6169L8.01188 21.1765C7.92692 21.657 8.34586 22.073 8.82633 21.991L12.3859 21.3669L20.0793 13.6736C20.217 13.5359 20.217 13.3132 20.0793 13.1755L16.8273 9.92358C16.6867 9.78589 16.464 9.78589 16.3263 9.92358ZM11.6359 16.9578C11.4748 16.7966 11.4748 16.5388 11.6359 16.3777L16.1476 11.866C16.3088 11.7048 16.5666 11.7048 16.7277 11.866C16.8888 12.0271 16.8888 12.2849 16.7277 12.446L12.216 16.9578C12.0548 17.1189 11.797 17.1189 11.6359 16.9578ZM10.5783 19.4216H11.9845V20.4851L10.0949 20.8162L9.18375 19.905L9.51481 18.0154H10.5783V19.4216Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4771_21968"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(8 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.551b251ade9f2d35efca6e37a3fced7f.svg";
export { ForwardRef as ReactComponent };